import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_ENABLE_DEVELOPER_APIS_BEGIN,
  APP_SETTING_ENABLE_DEVELOPER_APIS_SUCCESS,
  APP_SETTING_ENABLE_DEVELOPER_APIS_FAILURE,
  APP_SETTING_ENABLE_DEVELOPER_APIS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function enableDeveloperApis(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ENABLE_DEVELOPER_APIS_BEGIN,
    });
    const { projectId, version, settingType } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/developer-apis/enable-api`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_ENABLE_DEVELOPER_APIS_SUCCESS,
            data: res.data,
          });
          const routeData =
            res &&
            res.data &&
            res.data.find(
              (el) =>
                el.collectionName === args.collectionName &&
                el.url === args.url &&
                el.method === args.method,
            );
          if (routeData) {
            if (settingType === 'enable') {
              toast.success(
                routeData.enable ? 'API Enabled Successfully!' : 'API Disabled Successfully!',
              );
            } else if (settingType === 'auth') {
              toast.success(routeData.auth ? 'Authorization Enabled!' : 'Authorization Disabled!');
            } else if (settingType === 'userAuthenticate') {
              toast.success(
                routeData.userAuthenticate
                  ? 'User Authentication Enabled!'
                  : 'User Authentication Disabled!',
              );
            }
          }
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ENABLE_DEVELOPER_APIS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissEnableDeveloperApisError() {
  return {
    type: APP_SETTING_ENABLE_DEVELOPER_APIS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ENABLE_DEVELOPER_APIS_BEGIN:
      return {
        ...state,
        enableDeveloperApisPending: true,
        enableDeveloperApisError: null,
      };

    case APP_SETTING_ENABLE_DEVELOPER_APIS_SUCCESS:
      return {
        ...state,
        enableDeveloperApisPending: false,
        enableDeveloperApisError: null,
        projectDevApis: action.data,
      };

    case APP_SETTING_ENABLE_DEVELOPER_APIS_FAILURE:
      return {
        ...state,
        enableDeveloperApisPending: false,
        enableDeveloperApisError: action.data.error,
      };

    case APP_SETTING_ENABLE_DEVELOPER_APIS_DISMISS_ERROR:
      return {
        ...state,
        enableDeveloperApisError: null,
      };

    default:
      return state;
  }
}
